import { getSidepanelTabNavigationContext } from './sidepanel-tab-navigation-context';
import { TabId } from './sidepanel-types';

/**
 * Reusable hook for navigating to Activity Log tab with optional event timestamp.
 * Can be used in any tab component within a device layout.
 *
 * @returns Object with navigateToHistoryTab function
 */
export const useNavigateToHistoryTab = () => {
	const context = getSidepanelTabNavigationContext();

	if (!context) {
		console.warn(
			'useNavigateToHistoryTab: Navigation context not found. Make sure the component is within a device layout that provides the context.',
		);
		return {
			navigateToHistoryTab: () => {
				console.warn('Navigation context not available');
			},
		};
	}

	const navigateToHistoryTab = (openedEventTimestamp?: number) => {
		// Try 'history' first, then fallback to 'activity_log' for devices that use ActivityLog tab
		let tabId: TabId = TabId.HISTORY;
		let historyTabIndex = context.getTabIndex(TabId.HISTORY);

		if (historyTabIndex === -1) {
			historyTabIndex = context.getTabIndex(TabId.ACTIVITY_LOG);
			if (historyTabIndex !== -1) {
				tabId = TabId.ACTIVITY_LOG;
			}
		}

		if (historyTabIndex === -1) {
			console.warn('History or ActivityLog tab not found in tabs configuration');
			return;
		}

		context.navigateToTab(tabId, { openedEventTimestamp });
	};

	return { navigateToHistoryTab };
};
